// extracted by mini-css-extract-plugin
var _1 = "DropdownStyle-module__dropdown___E0yfp";
var _2 = "DropdownStyle-module__dropdown-holder___tt3Q1";
var _3 = "DropdownStyle-module__dropdown-holder___tt3Q1";
export { _1 as "dropdown", _2 as "dropdown-holder", _3 as "dropdownHolder" }
